export default __webpack_public_path__ + "static/media/delievers9.e04f4409.png";